<template>
  <b-button @click="clearDesign" :disabled="!imageExists">
    <b-icon-plus-square aria-hidden="true"></b-icon-plus-square>
    New
  </b-button>
</template>

<script>
import { mapState } from 'vuex';

import { BIconPlusSquare } from 'bootstrap-vue';

export default {
  name: 'DesignNew',
  components: {
    BIconPlusSquare,
  },
  props: {
    // msg: String,
  },
  computed: {
    imageExists() {
      let exists = false;
      Object.values(this.designs).forEach((design) => {
        if (design.image && design.image.key) {
          exists = true;
        }
      });
      return exists;
    },
    ...mapState(['designs']),
  },
  methods: {
    clearDesign() {
      // console.log('clearDesign');
      this.$store.commit('clearDesigns');
      this.$emit('clear');
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
